import { render, staticRenderFns } from "./Instructions3.vue?vue&type=template&id=013813a8&"
import script from "./Instructions3.vue?vue&type=script&lang=js&"
export * from "./Instructions3.vue?vue&type=script&lang=js&"
import style0 from "./Instructions3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports